import Button from "../../../../../../components/elements/Button/Button";
import {useIntl} from "react-intl";
import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import errorParser from "../../../../../../components/ErrorParser/ErrorParser";
import {useNavigate, useOutletContext, useParams} from "react-router-dom";
import moment from "moment/moment";
import DatePicker from "react-datepicker";
import Selector from "../../../../../../components/elements/Selector/Selector";
import LoadingComp from "../../../../../../components/elements/LoadingComp/LoadingComp";
import ModalMentions from "../../../../../../components/ModalMentions/ModalMentions";
import {eventTypeCatering, eventTypeSalon} from "../../../../../../utils/constants";
import ModalComp from "../../../../../../components/ModalComp/ModalComp";
import ModalCancelEvent from "../../../../../../components/ModalCancelEvent/ModalCancelEvent";
import ModalConfirm from "../../../../../../components/ModalConfirm/ModalConfirm";

export default function Details() {

    const intl = useIntl();
    const inputRef = useRef()
    const jwt = localStorage.getItem('jwt')
    const userAccess = JSON.parse(localStorage.getItem('access'))
    const access = userAccess && userAccess.events
    let params = useParams();

    const [eventName, setEventName] = useState()
    const [event, setEvent] = useState()
    const [eventType, setEventType] = useState()
    const [eventTypes, setEventTypes] = useState([])
    const [eventStatus, setEventStatus] = useState()
    const [tags, setTags] = useState([])
    const [tagsOptions, setTagsOptions] = useState([])
    const [source, setSource] = useState(0)
    const [sources, setSources] = useState([])
    const [eventDate, setEventDate] = useState()
    const [installationDate, setInstallationDate] = useState()
    const [agency, setAgency] = useState(null)
    const [numberOfGuests, setNumberOfGuests] = useState(null)
    const [agencies, setAgencies] = useState([])
    const [loadingAddMentions, setLoadingAddMentions] = useState(false)

    const [loading, setLoading] = useState(true)
    const [saveLoading, setSaveLoading] = useState(false)
    const [closeLoading, setCloseLoading] = useState(false)

    const [timeStart, setTimeStart] = useState(null)
    const [deleteAfter, setDeleteAfter] = useState('')
    const [deleteLoading, setDeleteLoading] = useState(false)
    const [duration, setDuration] = useState(1)
    const [canConfirm, setCanConfirm] = useState(false)
    const [message, setMessage] = useState('')
    const [file, setFile] = useState(null)
    const [fileUrl, setFileUrl] = useState('')
    const navigate = useNavigate()

    const [modalMentionsIsOpen, setModalMentionsIsOpen] = useState(false)
    const [mentionsHistory, setMentionsHistory] = useState([])
    const [mentions, setMentions] = useState('')
    const [location, setLocation] = useState(0)
    const [textLocation, setTextLocation] = useState('')
    const [locations, setLocations] = useState([])


    const [showConfirmButton, setShowConfirmButton] = useState(true)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [modalTitle, setModalTitle] = useState(false)
    const [modalDescription, setModalDescription] = useState(false)
    const [needVerification, setNeedVerification] = useState(false)
    const [modalCanceledIsOpen, setModalCanceledIsOpen] = useState(false)
    const [canceledMessage, setCanceledMessage] = useState('')
    const [modalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
    const [modalCloseIsOpen, setModalCloseIsOpen] = useState(false)
    const {context, ended} = useOutletContext()

    useEffect(() => {
        if (access)
            getLocations()
        else
            getData()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getLocations = async () => {
        axios.get(process.env.REACT_APP_API + '/locations', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                var items = [];
                response.data.forEach((item) => {
                    items.push({
                        value: item.id,
                        label: item.title,
                        image: item.image,
                        icon: item.icon,
                        type: item.type,
                    })
                })
                setLocations(items)
                getAgencies()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getAgencies = async () => {
        axios.post(process.env.REACT_APP_API + '/clients/list/0', {agency: 1}, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                var itemsAgencies = [];
                response.data.clients.forEach((item) => {
                    itemsAgencies.push({
                        value: item.id,
                        label: item.company_title
                    })

                })
                setAgencies(itemsAgencies)
                getData()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getData = async () => {
        axios.get(process.env.REACT_APP_API + '/events/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                if (response.data) {
                    setEvent(response.data)
                    setEventName(response.data.title)
                    setEventType(response.data.event_type)
                    if (response.data.text_location)
                        setTextLocation(response.data.text_location)
                    setEventStatus(response.data.status)
                    setTags(response.data.tags.map(item => item.id))
                    setAgency(response.data.agency)
                    setSource(response.data.source)
                    setNumberOfGuests(response.data.number_of_guests)
                    setLocation(response.data.location ? response.data.location.id : 0)

                    let temp = []
                    if (response.data.location)
                        if (response.data.location.type === 'catering') {
                            for (let i = 0; i < eventTypeCatering.length; i++) {
                                temp.push({
                                    value: eventTypeCatering[i],
                                    label: intl.formatMessage({id: 'general.event_type.' + eventTypeCatering[i]})
                                })
                            }
                        } else {
                            for (let i = 0; i < eventTypeSalon.length; i++) {
                                temp.push({
                                    value: eventTypeSalon[i],
                                    label: intl.formatMessage({id: 'general.event_type.' + eventTypeSalon[i]})
                                })
                            }
                        }

                    setEventTypes(temp)

                    setEventDate(new Date(response.data.start))
                    setInstallationDate(response.data.installation_date ? new Date(response.data.installation_date) : '')
                    setDeleteAfter(response.data.delete_after ? new Date(response.data.delete_after) : '')
                    setTimeStart(new Date(response.data.start))
                    setDuration((parseInt(moment(response.data.end).unix()) -
                        parseInt(moment(response.data.start).unix())) / (60 * 60 * (response.data.event_type === 'festival' ? 24 : 1)))
                    setCanConfirm(response.data.can_confirm)
                    if (!response.data.can_confirm && response.data.status !== 'confirmed') {
                        setMessage(intl.formatMessage({id: 'events.confirm_event_message_1'}))
                    }
                    if (response.data.hall_plan)
                        setFileUrl(process.env.REACT_APP_API + response.data.hall_plan.url)
                }
                getTags()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getTags = async () => {
        axios.get(process.env.REACT_APP_API + '/event-tags', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let temp = []
                for (let i = 0; i < response.data.tags.length; i++) {
                    temp.push({
                        value: response.data.tags[i].id,
                        label: response.data.tags[i].title
                    })
                }
                setTagsOptions(temp)
                getSources()
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const getSources = async () => {
        axios.get(process.env.REACT_APP_API + '/event-sources', {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                let temp = []
                response.data.sources.forEach(item => {
                    temp.push({
                        value: item.id,
                        label: item.title
                    })
                })
                setSources(temp)
                setLoading(false)
            })
            .catch(err => {
                errorParser(err, intl)
            })
    }

    const verify = async () => {
        let response = await verifyEvent()

        if (response.status) {
            if (response.alert) {
                setModalTitle(intl.formatMessage({id: 'events.verifications_messages.title_' + response.event_status}))
                setModalDescription(intl.formatMessage({id: 'events.verifications_messages.case_' + response.case}))
                switch (response.case) {
                    case 1: //avem o nunta/botez confirmat
                    case 2: //avem un eveniment in acelasi interval orar
                        setModalIsOpen(true)
                        break
                    case 3:
                    case 4:
                        // poate adauga doar rezervare
                        setShowConfirmButton(true)
                        setModalIsOpen(true)
                        break
                    default:
                        save()
                        break
                }
            } else {
                save()
            }
        }
    }

    async function verifyEvent() {
        let d = moment(eventDate);
        let t = moment(eventDate);
        if (timeStart !== null) {
            let temp = moment(timeStart)
            t.hours(temp.hours());
            t.minutes(temp.minutes())
            t.seconds(0)
        }
        let payload = {
            event_type: eventType,
            date: d.format('YYYY-MM-DD'),
            time_start: timeStart !== null ? t.toISOString() : null,
            duration: eventType === 'festival' ? 24 * duration : duration,
            location: location,
            current_event: params.id
        }
        let r = []
        await axios.post(process.env.REACT_APP_API + '/events/filter-overlap', payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then(async (response) => {
            if (response.status) {
                r = await response.data
            } else {
                toast.error(intl.formatMessage({id: 'errors.unknown'}))
            }


        }).catch(err => {
            errorParser(err, intl)
        })
        return r;
    }

    if (loading) {
        return <LoadingComp/>
    }

    const save = async () => {
        if (eventType === '') {
            toast.error(intl.formatMessage({id: "errors.please_fill_all_fields"}))
            return
        }

        if (eventStatus === 'canceled' && canceledMessage === '') {
            setModalCanceledIsOpen(true)
            return
        }
        setSaveLoading(true)
        let start = moment(eventDate).startOf('day');
        let end = moment(eventDate).endOf('day');

        if (timeStart) {
            start.hour(moment(timeStart).hour());
            start.minute(moment(timeStart).minute());

            let hours = parseInt(moment(timeStart).hour()) + parseInt(event.event_type === 'festival' ? 24 * duration : duration)
            end.hour(hours % 24);

            end.minute(moment(timeStart).minute());
            end.second(0)
            end.utc(false)
            start.utc(false)
            if (hours >= 24) {
                end.add(parseInt(hours / 24), 'day');
            }

            end.millisecond(0)
        }

        end.utc(false)
        start.utc(false)
        let formData = new FormData()
        formData.append('data', JSON.stringify({
            title: eventName,
            delete_after: deleteAfter,
            start: start.toISOString(),
            end: end.toISOString(),
            status: eventStatus,
            location: location,
            text_location: textLocation,
            event_type: eventType,
            installation_date: moment(installationDate).toISOString(),
            number_of_guests: numberOfGuests,
            cancellation_reason: canceledMessage,
            tags,
            agency,
            source
        }))
        if (file) {
            formData.append('hall_plan', file)
        }

        await axios.put(process.env.REACT_APP_API + '/events/details/' + params.id, formData, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                context.setContentUpdated(false)
                getData()
                if (eventStatus === 'canceled')
                    window.location.reload()
            })
            .catch(err => {
                errorParser(err, intl)
            })
        setSaveLoading(false)
    }
    const closeEvent = async () => {
        setCloseLoading(true)

        await axios.get(process.env.REACT_APP_API + '/events/close/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                window.location.reload()
            })
            .catch(err => {
                setCloseLoading(false)
                errorParser(err, intl)
            })
    }
    const deleteEvent = async () => {
        setDeleteLoading(true)
        await axios.delete(process.env.REACT_APP_API + '/events/' + params.id, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        })
            .then(async (response) => {
                toast.success(intl.formatMessage({id: 'errors.success.data_has_been_saved'}))
                navigate('/calendar')
            })
            .catch(err => {
                errorParser(err, intl)
            })
        setDeleteLoading(false)
    }


    const addMentions = async (e) => {
        e.preventDefault();
        setLoadingAddMentions(true)
        let ment = mentionsHistory;
        ment.push({
            user: 'owner',
            note: mentions,
            date: moment(),
            user_id: event.user.id

        })
        let payload = {
            mentions: ment,
            user: 'owner'
        }
        axios.post(process.env.REACT_APP_API + '/events/add-mentions/' + event.id, payload, {
            headers: {
                'Authorization': 'Bearer ' + jwt
            }
        }).then((response) => {
            getData();
            //     setModalMentionsIsOpen(false)
            setMentions('')
            setLoadingAddMentions(false)
        })
            .catch(err => {
                errorParser(err, intl)
                setLoadingAddMentions(false)
            })
    }


    return (
        <div className="card">
            <div className={"header "}>

                <div className={"row"}>
                    <div className={"col-md-4 col-sm-12"}>
                        <p className={"d-inline-flex"}>{intl.formatMessage({id: 'events.event_details'})}
                        </p>
                    </div>

                    {access && !ended  && <div className={"col-md-8 col-sm-12"}>

                        {event.status === 'confirmed' && <Button
                            className={"btn-primary ms-2"}
                            style={{float: 'right'}}
                            value={intl.formatMessage({id: 'events.close_event'})}
                            onClick={() => {
                                setModalCloseIsOpen(true)
                            }}
                        />}
                        <Button
                            className={"btn-primary "}
                            style={{float: 'right'}}
                            value={intl.formatMessage({id: 'contracts.client.add_mentions'})}
                            onClick={() => {
                                context.setContentUpdated(true)
                                setMentionsHistory(event.mentions ?? [])
                                setModalMentionsIsOpen(true)
                            }}
                        />
                    </div>}

                </div>

            </div>

            <form onSubmit={(e) => {
                e.preventDefault()
                if (needVerification)
                    verify()
                else
                    save()
            }}>
                <div className={"content"}>
                    <div className={"row"}>

                        <div className={"col-12"}>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.event_name'})}<span
                                    className={"form-required"}>*</span></div>
                                <input type={"text"} className={"form-input"}
                                       value={eventName} required
                                       disabled={!access || ended}
                                       onChange={(e) => {
                                           context.setContentUpdated(true)
                                           setEventName(e.target.value)
                                       }}
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.location'})}<span
                                    className={"form-required"}>*</span></div>
                                <Selector
                                    disabled={!access || ended}
                                    options={locations}
                                    value={location}

                                    onChange={(option) => {
                                        setNeedVerification(true)
                                        context.setContentUpdated(true)
                                        let temp = []
                                        if (option.type === 'catering') {
                                            setEventType(eventTypeCatering[0])
                                            for (let i = 0; i < eventTypeCatering.length; i++) {
                                                temp.push({
                                                    value: eventTypeCatering[i],
                                                    label: intl.formatMessage({id: 'general.event_type.' + eventTypeCatering[i]})
                                                })
                                            }
                                        } else {
                                            for (let i = 0; i < eventTypeSalon.length; i++) {
                                                setEventType(eventTypeSalon[0])
                                                temp.push({
                                                    value: eventTypeSalon[i],
                                                    label: intl.formatMessage({id: 'general.event_type.' + eventTypeSalon[i]})
                                                })
                                            }
                                        }
                                        setEventTypes(temp)
                                        setLocation(option.value)
                                    }}
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'menus.event_type'})}<span
                                    className={"form-required"}>*</span></div>
                                <Selector
                                    disabled={!access || ended}
                                    options={eventTypes}
                                    value={eventType}
                                    key={eventType}
                                    onChange={(option) => {
                                        context.setContentUpdated(true)
                                        setEventType(option.value)
                                    }}
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.event_status'})}<span
                                    className={"form-required"}>*</span></div>
                                <Selector
                                    disabled={!access || ended}
                                    options={[{
                                        value: 'booked',
                                        disabled: event.status === 'confirmed',
                                        label: intl.formatMessage({id: 'events.status.booked'})
                                    }, {
                                        disabled: !canConfirm,
                                        value: 'confirmed',
                                        label: intl.formatMessage({id: 'events.status.confirmed'})
                                    }, {
                                        value: 'canceled',
                                        label: intl.formatMessage({id: 'events.status.canceled'})
                                    }]}
                                    value={eventStatus}
                                    onChange={(option) => {
                                        if (option.value !== 'canceled')
                                            setNeedVerification(true)
                                        context.setContentUpdated(true)
                                        setEventStatus(option.value)
                                    }}
                                    isSearchable={true}
                                    isOptionDisabled={(option) => option.disabled}
                                />
                                {message && eventStatus !== 'canceled' && <div className={"alert alert-warning mt-2"}>
                                    {message}
                                </div>}
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.tags'})}</div>
                                <Selector
                                    options={tagsOptions}
                                    value={tags}
                                    onChange={(option) =>
                                        setTags(Array.from(option, option => option.value))}
                                    isSearchable={true}
                                    disabled={!access || ended}
                                    isOptionDisabled={(option) => option.disabled}
                                    isMulti
                                />
                            </div>

                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.source'})}</div>
                                <Selector
                                    options={sources}
                                    value={source}
                                    disabled={!access || ended}
                                    onChange={(option) =>
                                        setSource(option.value)}
                                    isSearchable={true}
                                    isOptionDisabled={(option) => option.disabled}
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.agency'})}</div>
                                <Selector
                                    options={agencies}
                                    value={agency}
                                    onChange={(option) => setAgency(option.value)}
                                    isSearchable={true}
                                    disabled={!access || ended}
                                    isOptionDisabled={(option) => option.disabled}
                                />
                            </div>

                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.number_of_guests'})}<span
                                    className={"form-required"}>*</span></div>
                                <input type={"number"} className={"form-input"} min={1}
                                       value={numberOfGuests} required
                                       disabled={!access || ended}
                                       onFocus={(event) => event.target.select()}
                                       onChange={(e) => {
                                           context.setContentUpdated(true)
                                           setNumberOfGuests(e.target.value)
                                       }}
                                />
                            </div>
                            {
                                eventStatus === 'booked' &&
                                <div className={"form-control"}>
                                    <div
                                        className={"form-label"}>{intl.formatMessage({id: 'events.delete_after'})}</div>
                                    <DatePicker
                                        disabled={!access || ended}
                                        locale={moment.locale()}
                                        selected={deleteAfter}
                                        minDate={new Date()}
                                        onChange={(date) => {
                                            context.setContentUpdated(true)
                                            setDeleteAfter(date)
                                        }}
                                        requires
                                        className={"form-input"}
                                    />
                                </div>
                            }
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.event_date'})}<span
                                    className={"form-required"}>*</span></div>
                                <DatePicker
                                    disabled={!access || ended}
                                    locale={moment.locale()}
                                    className={"form-input"}
                                    selected={eventDate}
                                    minDate={new Date()}
                                    onChange={(date) => {
                                        setNeedVerification(true)
                                        context.setContentUpdated(true)
                                        setEventDate(date)
                                    }}
                                    required
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.time_start'})}</div>
                                <DatePicker
                                    disabled={!access || ended}
                                    timeCaption={intl.formatMessage({id: 'events.time'})}
                                    locale={moment.locale()}
                                    selected={timeStart}
                                    onChange={(date) => {
                                        setNeedVerification(true)
                                        context.setContentUpdated(true)
                                        setTimeStart(date)
                                    }}
                                    showTimeSelectOnly showTimeSelect dateFormat={"HH:mm"}
                                    timeFormat="HH:mm"
                                    className={"form-input"}/>
                            </div>

                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.duration' + (event.event_type === 'festival' ? '_days' : '')})}</div>
                                <input type={"number"} className={"form-input"} min={1}
                                       max={['wedding', 'christening'].includes(event.event_type) ? 12 : 72}
                                       value={duration} required
                                       disabled={!access || ended}
                                       onFocus={(event) => event.target.select()}
                                       onChange={(e) => {
                                           setNeedVerification(true)
                                           context.setContentUpdated(true)
                                           setDuration(e.target.value)
                                       }}
                                />
                            </div>

                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.event_installation_date'})}</div>
                                <DatePicker
                                    disabled={!access || ended}
                                    locale={moment.locale()}
                                    className={"form-input"}
                                    selected={installationDate}
                                    minDate={new Date()}
                                    onChange={(date) => {
                                        context.setContentUpdated(true)
                                        setInstallationDate(date)
                                    }}
                                />
                            </div>
                            <div className={"form-control"}>
                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'general.other_details'})}</div>
                                <textarea className={"form-input"} rows={5}
                                          style={{height: 'unset'}}
                                          placeholder={intl.formatMessage({id: 'events.staff.add_message'})}
                                          disabled={!access || ended}
                                          value={textLocation}
                                          onChange={(e) => setTextLocation(e.target.value)}
                                />
                            </div>
                            {access && !ended && <div className={"form-control"}>

                                <div
                                    className={"form-label"}>{intl.formatMessage({id: 'events.hall_plan'})}</div>
                                <div className={"tab-content p-2"} style={{borderRadius: '8px'}}>
                                    <div>
                                        <input type={"file"}
                                               accept=".doc,.docx,.pdf"
                                               ref={inputRef}
                                               style={{display: "none"}}
                                               multiple={false}
                                               onChange={(e) => {
                                                   if (e.target.files[0] && access && !ended) {
                                                       context.setContentUpdated(true)
                                                       setFile(e.target.files[0])
                                                   }
                                               }}
                                        />
                                        <div className={"upload-image-comp"}
                                             onClick={() => access && !ended && inputRef.current.click()}>
                                            {
                                                file !== null ?
                                                    <div className={"preview"}>
                                                        <img src={''} alt={""}/>
                                                        <div>
                                                            <i style={{fontSize: '2rem'}}
                                                               className="fa-regular fa-file"></i>
                                                            <div
                                                                className={"title"}>{file.name}</div>
                                                        </div>
                                                    </div>
                                                    :

                                                    <>
                                                        <i className="fa-regular fa-images icon"></i>
                                                        <div
                                                            className={"title"}>{intl.formatMessage({id: "general.upload.excel.title"})}</div>
                                                        <div
                                                            className={"info"}>{intl.formatMessage({id: "general.upload.pdf_doc_docx.info"})}</div>
                                                    </>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>}

                            <div className={"form-control"}>
                                {fileUrl !== '' && <a
                                    className={"btn btn-primary mt-2 d-flex justify-content-center align-items-center"}
                                    type={'button'}
                                    href={fileUrl}
                                    rel={"noreferrer"}
                                    target={"_blank"}
                                ><i className={"fa-solid fa-trash me-2"}/> {intl.formatMessage({id: 'general.buttons.download_hall_plan'})}
                                </a>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"footer"}>
                    <div className={"row"}>
                        {event.user !== null && <div className={"col-12 mb-2"}>
                            {intl.formatMessage({id: 'events.added_by'})}: {event.user.first_name} {event.user.last_name}
                        </div>}
                        <div className={"col-md-6 col-sm-12 d-flex"}>
                            {
                                access && !ended &&
                                <Button
                                    className={"btn-primary mt-2"}
                                    icon={"fa-solid fa-trash"}
                                    value={intl.formatMessage({id: 'general.buttons.delete'})}
                                    type={'button'}
                                    onClick={() => {
                                        setModalDeleteIsOpen(true)
                                    }}
                                />
                            }
                        </div>
                        <div className={"col-md-6 col-sm-12 d-flex"}>
                            {access && !ended && <Button
                                className={"btn-secondary mt-2 ms-auto"}
                                icon={"fa-regular fa-floppy-disk"}
                                value={intl.formatMessage({id: 'general.buttons.save'})}
                                type={'submit'}
                                disabled={saveLoading}
                                loading={saveLoading}
                            />}
                        </div>

                        {
                            window.alityAppView &&
                            <div className={"col-12"}>
                                <Button
                                    className={"btn-light mt-2"}
                                    icon={"fa-solid fa-chevron-left"}
                                    value={intl.formatMessage({id: 'general.buttons.back'})}
                                    onClick={() => {

                                        context.setLeavePage(true)
                                        context.setNextLink('/calendar')
                                    }}
                                />
                            </div>
                        }
                    </div>
                </div>
            </form>

            <ModalMentions
                modalMentionsIsOpen={modalMentionsIsOpen}
                setModalMentionsIsOpen={setModalMentionsIsOpen}
                mentionsHistory={mentionsHistory}
                mentions={mentions}
                setMentions={setMentions}
                addMentions={addMentions}
                user={'owner'}
                loadingAddMentions={loadingAddMentions}
                contract={{event: event}}
            />

            <ModalComp
                title={modalTitle}
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                className={"subscription-limit exist-event-alert"}
            >
                <div className={"content"}>
                    {modalDescription}
                </div>
                <div className={"footer"}>
                    <div className={"row"}>
                        <div className={"col-12 d-flex"}>

                            {
                                showConfirmButton &&
                                <Button
                                    className={"btn-primary mt-2"}
                                    value={intl.formatMessage({id: 'events.confirm'})}
                                    type={"button"}
                                    onClick={(e) => {
                                        save(e)
                                        setModalIsOpen(false)
                                    }}
                                />
                            }
                            <Button
                                className={"btn-primary mt-2 ms-auto"}
                                value={intl.formatMessage({id: 'events.change_date'})}
                                type={"button"}
                                onClick={() => setModalIsOpen(false)}

                            />
                        </div>
                    </div>
                </div>
            </ModalComp>

            <ModalCancelEvent
                message={canceledMessage}
                setMessage={setCanceledMessage}
                loading={saveLoading}
                save={save}
                modalIsOpen={modalCanceledIsOpen}
                setModalIsOpen={setModalCanceledIsOpen}
            />
            <ModalConfirm loading={deleteLoading} onConfirm={deleteEvent}
                          title={intl.formatMessage({id: 'events.delete_event'})} modalIsOpen={modalDeleteIsOpen}
                          message={intl.formatMessage({id: 'events.confirm_delete_event_message'})}
                          onRequestClose={() => setModalDeleteIsOpen(false)}/>
            <ModalConfirm loading={closeLoading} onConfirm={closeEvent}
                          title={intl.formatMessage({id: 'events.close_event'})} modalIsOpen={modalCloseIsOpen}
                          message={intl.formatMessage({id: 'events.confirm_close_event_message'})}
                          onRequestClose={() => setModalCloseIsOpen(false)}/>
        </div>
    );
}

